import { render, staticRenderFns } from "./TrimSidebar.vue?vue&type=template&id=535c49d0&scoped=true&"
import script from "./TrimSidebar.vue?vue&type=script&lang=js&"
export * from "./TrimSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TrimSidebar.vue?vue&type=style&index=0&id=535c49d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535c49d0",
  null
  
)

export default component.exports